<template>
  <div>
    <div class="flex items-center justify-between" v-if="listType !== 'print-list'">
      <p class="text-2xl" v-if="listType !== 'preview'">
        <span >Entries</span>
      </p>
      <dropdown-button v-if="editable" ref="newEntryDD" class="w-56 text-right">
        <span slot="link" class="appearance-none flex items-center inline-block btn btn-blue">
          <span class="mr-1">New Entry</span>
          <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path style="fill:white;" d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
          </svg>
        </span>
        <div slot="dropdown" class="text-left bg-white shadow rounded border overflow-scroll h_dd">
          <div v-for="(a, i) in event.show_types" :key="i">
            <!--Needed to add a separate case for when i was 0-->
            <div v-if="i === 0 && (a.status === 'ADMIN' && isAdmin || a.status !== 'ADMIN')" class="text-xs font-bold p-1 border-b bg-gray-700 text-white">
              {{a.group_type}}
            </div>
            <div v-else-if="(i > 0 && (a.group_type !== event.show_types[i-1].group_type) && event.show_types.filter(st => st.group_type === a.group_type && (st.status !== 'ADMIN' || isAdmin)).length)" class="text-xs font-bold p-1 border-b bg-gray-700 text-white">
              {{a.group_type}}
            </div>
            <template v-if="a.status === 'ADMIN'">
              <a v-if="isAdmin" @click="() => {entryTypeClicked(a)}" class="no-underline block px-4 py-1 border-b text-gray-800 bg-white hover:text-white hover:bg-blue-500 hover:cusror-pointer">
                {{a.label}}
              </a>
            </template>
            <template v-else-if="a.status !== 'CLOSED' || isAdmin">
              <a @click="() => {entryTypeClicked(a)}" class="no-underline block px-4 py-1 border-b text-gray-800 bg-white hover:text-white hover:bg-blue-500 hover:cusror-pointer">
                {{a.label}}
              </a>
            </template>
            <template v-else>
              <a class="no-underline block px-4 py-1 border-b text-gray-700 bg-gray-400 cursor-not-allowed">
                {{a.label}} (CLOSED)
              </a>
            </template>
          </div>
        </div>
      </dropdown-button>
    </div>
    <template v-if="listType==='tabs'">
      <tabs ref="entryTabs" class="mt-4">
        <tab v-for="(a, i) in entryTabs" :key="i" :name="`${a.label} ${groupedEntries[a.type] ? `(${groupedEntries[a.type].length})` :''}`" :selected="i === 0">
          <showman-table v-if="groupedEntries[a.type]" class="mt-4" :hover="true" :tableData="groupedEntries[a.type]" :tableFields="entryFields" :showHeaders="false">
            <div slot="Entry" slot-scope="data">
              <div id="exhibitor-info" v-if="data.item.exhibitor" class="md:text-lg font-semibold">
                Exhibitor: {{data.item.exhibitor.first_name}} {{data.item.exhibitor.last_name}}
              </div>
              <div v-if="showDecode[data.item.shows[0]].entry_details.entry_details[0]">
                <span v-if="data.item.entry_details.name" class="font-medium text-lg md:text-xl">{{data.item.entry_details.name}}</span>
                <div class='flex flex-col justify-start text-gray-800 text-xs'>
                  <div v-if="data.item.entry_details.division">
                    <span class="font-medium">Division:</span>&nbsp;{{data.item.entry_details.division}}
                  </div>
                  <div v-for="(f, i) in showDecode[data.item.shows[0]].entry_details.entry_details[0].fields.filter(field => {return field.model !== 'name'})" :key="i">
                    <template v-if="(isAdmin || !f.admin_only) && f.model !== 'division' && f.model !== 'weight'">
                      <span class="font-medium">{{f.label}}:</span>&nbsp;
                      <template v-if="f.type==='picture'">
                        <img :src="data.item.entry_details[f.model]"/>
                      </template>
                      <template v-else-if="f.type==='video'">
                        <video width="320" height="240" controls>
                          <source :src="data.item.entry_details[f.model]" type="video/mp4">
                          <source :src="data.item.entry_details[f.model]" type="video/webm">
                          <source :src="data.item.entry_details[f.model]" type="video/ogg">
                        </video>
                      </template>
                      <template v-else-if="f.type==='file'">
                        <display-file-type-field :url="data.item.entry_details[f.model]" :tilte="`${f.label} - ${data.item.entry_details['animal_id']}`"/>
                      </template>
                      <template v-if="f.type==='link'">
                        <a v-if="data.item.entry_details[f.model]" :href="`${data.item.entry_details[f.model]}`" target="_blank" class="link">{{`${data.item.entry_details[f.model]}`}}</a>
                      </template>
                      <template v-if="f.inputType === 'text' || f.inputType === 'number' || f.type === 'select'">
                        <span class="p-0 md:pr-2">{{data.item.entry_details[f.model]}}</span>
                      </template>
                      <template v-else-if="f.inputType === 'date'">
                        <span class="p-0 md:pr-2" v-if="data.item.entry_details[f.model]">{{formatDate(data.item.entry_details[f.model])}}</span>
                      </template>
                      <template v-else-if="f.type === 'checkbox'">
                        <span class="font-bold p-0 md:pr-2">{{data.item.entry_details[f.model] ? 'Yes' : 'No'}}</span>
                      </template>
                    </template>
                  </div>
                  <div v-if="data.item.entry_details.weight" class="text-base mt-1">
                    <span class="font-medium">{{getWeightLabel(data.item) }}:</span>&nbsp;{{data.item.entry_details.weight}}
                  </div>
                </div>
                <template v-if="showDecode[data.item.shows[0]].entry_details.entry_details[0].sub_entry_details" >
                  <div v-for="(s, i) in showDecode[data.item.shows[0]].entry_details.entry_details[0].sub_entry_details" :key="i" class='flex flex-col justify-start text-gray-800'>
                    <div v-for="(f, j) in s[0].fields" :key="j" class="text-xs leading-none">
                      <template v-if="f.inputType === 'text' || f.inputType === 'number'">
                        <span class="p-0 md:pr-2" v-if="f.model !== 'name'">{{data.item.entry_details[f.model]}}</span>
                      </template>
                      <template v-else-if="f.inputType === 'date'">
                        <span class="p-0 md:pr-2" v-if="data.item.entry_details[f.model]">{{formatDate(data.item.entry_details[f.model])}}</span>
                      </template>
                      <template v-else-if="f.type === 'checkbox'">
                        <span class="font-bold p-0 md:pr-2" >{{data.item.entry_details[f.model] ? 'Yes' : 'No'}}</span>
                      </template>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div slot="Class" slot-scope="data">
              <div v-if="data.item.shows" class="text-lg md:text-xl">
                <div v-for="(show, i) in data.item.shows" :key="i" class="">
                  {{showDecode[show].name}}
                </div>
              </div>
              <div v-if="entryTypeDecode[showDecode[data.item.shows[0]].entry_details_id].class_list.length > 1" class="text-sm md:text-base text-gray-800" v-html="getClassName(data.item)"></div>
            </div>
            <div slot=" " slot-scope="data" v-if="editable && checkEntryTypeEditable(data.item)">
              <div class="flex flex-col md:flex-row justify-center" v-if="!data.item.checked_in">
                <button class="btn btn-link mb-2 md:mb-0" @click="$refs.entryEdit.editEntryClicked(entryTypeDecode[showDecode[data.item.shows[0]].entry_details_id], data.item, entryGroup.entry_group_id, entryGroup.user.user_id)">Edit</button>
                <button @click="scratchEntry(data.item)" class="btn btn-link">Delete</button>
              </div>
              <div v-else class="font-bold text-xs md:text-base text-gray-800 text-center">
                Entry Checked In
              </div>
            </div>
          </showman-table>
          <div v-else class="">
            <p class="text-center pt-6 text-xl">No {{a.label}} Entries Submitted</p>
          </div>
        </tab>
      </tabs>
    </template>
    <template v-else-if="listType === 'list'">
      <div class="hr"></div>
      <div v-for="(a, i) in entryTabs" :key="i">
        <div v-if="groupedEntries[a.type]"  class="mb-6 border rounded-t">
          <p class="w-full text-xl font-semibold bg-gray-400 p-1 rounded-t">{{`${a.label} (${groupedEntries[a.type] ? groupedEntries[a.type].length :0})`}}</p>
          <showman-table v-if="groupedEntries[a.type]" :hover="true" :tableData="groupedEntries[a.type]" :tableFields="entryFields" :showHeaders="false">
            <div slot="Entry" slot-scope="data">
              <div id="exhibitor-info" v-if="data.item.exhibitor" class="md:text-lg font-semibold">
                Exhibitor: {{data.item.exhibitor.first_name}} {{data.item.exhibitor.last_name}}
              </div>
              <div v-if="showDecode[data.item.shows[0]].entry_details.entry_details[0]">
                <span v-if="data.item.entry_details.name" class="font-semibold text-lg md:text-xl">{{data.item.entry_details.name}}</span>

                <div class='flex flex-col justify-start text-gray-800 text-xs'>
                  <div v-if="data.item.entry_details.division">
                    <span class="font-medium">Division:</span>&nbsp;{{data.item.entry_details.division}}
                  </div>
                  <div v-for="(f, i) in showDecode[data.item.shows[0]].entry_details.entry_details[0].fields" :key="i" v-show="f.model !== 'name'" class="flex items-center">
                    <template v-if="(isAdmin || !f.admin_only) && f.model !== 'division' && f.model !== 'weight'">
                      <span class="font-medium">{{f.label}}:</span>&nbsp;
                      <template v-if="f.type==='picture'">
                        <img :src="data.item.entry_details[f.model]"/>
                      </template>
                      <template v-else-if="f.type==='video'">
                        <video width="320" height="240" controls>
                          <source :src="data.item.entry_details[f.model]" type="video/mp4">
                          <source :src="data.item.entry_details[f.model]" type="video/webm">
                          <source :src="data.item.entry_details[f.model]" type="video/ogg">
                        </video>
                      </template>
                      <template v-else-if="f.type==='file'">
                        <display-file-type-field :url="data.item.entry_details[f.model]" :title="`${f.label} - ${data.item.entry_details['animal_id']}`"/>
                      </template>
                      <template v-if="f.type==='link'">
                        <a v-if="data.item.entry_details[f.model]" :href="`${data.item.entry_details[f.model]}`" target="_blank" class="link">{{`${data.item.entry_details[f.model]}`}}</a>
                      </template>
                      <template v-if="f.inputType === 'text' || f.inputType === 'number' || f.type === 'select'">
                        <span class="p-0 md:pr-2">{{data.item.entry_details[f.model]}}</span>
                      </template>
                      <template v-else-if="f.inputType === 'date'">
                        <span class="p-0 md:pr-2" v-if="data.item.entry_details[f.model]">{{formatDate(data.item.entry_details[f.model])}}</span>
                      </template>
                      <template v-else-if="f.type === 'checkbox'">
                        <span class="font-bold p-0 md:pr-2">{{data.item.entry_details[f.model] ? 'Yes' : 'No'}}</span>
                      </template>
                    </template>
                  </div>
                  <div v-if="data.item.entry_details.weight" class="text-base mt-1">
                    <span class="font-medium">{{ getWeightLabel(data.item) }}:</span>&nbsp;{{data.item.entry_details.weight}}
                  </div>
                </div>
                <template v-if="showDecode[data.item.shows[0]].entry_details.entry_details[0].sub_entry_details" >
                  <div v-for="(s, i) in showDecode[data.item.shows[0]].entry_details.entry_details[0].sub_entry_details" :key="i" class='flex flex-col justify-start text-gray-800'>
                    <div v-for="(f, j) in s[0].fields" :key="j" class="text-xs leading-none">
                      <template v-if="f.inputType === 'text' || f.inputType === 'number'">
                        <span class="p-0 md:pr-2" v-if="f.model !== 'name'">{{data.item.entry_details[f.model]}}</span>
                      </template>
                      <template v-else-if="f.inputType === 'date'">
                        <span class="p-0 md:pr-2" v-if="data.item.entry_details[f.model]">{{formatDate(data.item.entry_details[f.model])}}</span>
                      </template>
                      <template v-else-if="f.type === 'checkbox'">
                      <span class="font-bold p-0 md:pr-2">{{data.item.entry_details[f.model] ? 'Yes' : 'No'}}</span>
                      </template>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div slot="Class" slot-scope="data">
              <div v-if="data.item.shows" class="text-lg md:text-xl">
                <div v-for="(show, i) in data.item.shows" :key="i" class="">
                  {{showDecode[show].name}}
                </div>
              </div>
              <div v-if="entryTypeDecode[showDecode[data.item.shows[0]].entry_details_id].class_list.length > 1" class="text-sm md:text-base text-gray-800" >{{getClassName(data.item)}}</div>
            </div>
            <div slot=" " slot-scope="data" v-if="event.status !== 'ARCHIVED'">
              <div class="flex flex-col md:flex-row justify-center" v-if="!data.item.checked_in">

                <div v-if="editable && checkEntryTypeEditable(data.item)">
                  <button class="btn btn-link mb-2 md:mb-0" @click="$refs.entryEdit.editEntryClicked(entryTypeDecode[showDecode[data.item.shows[0]].entry_details_id], data.item, entryGroup.entry_group_id, entryGroup.user.user_id)">Edit</button>
                  <button v-if="!event.event_settings.disable_delete_after_enter" @click="scratchEntry(data.item)" class="btn btn-link">Delete</button>
                </div>
                <div v-else-if="event.entry_settings.use_exhibitor_declared_weights && (entryTypeDecode[showDecode[data.item.shows[0]].entry_details_id].entry_details[0].fields.findIndex(f=> {return f.model === 'weight'})>= 0)">
                  <button class="btn btn-link mb-2 md:mb-0" @click="$refs.entryEdit.editWeightClicked(data.item, entryGroup.entry_group_id)">Edit Declared Weight</button>
                </div>
              </div>
              <div v-else class="font-bold text-xs md:text-base text-gray-800 text-center">
                Entry Checked In
              </div>
            </div>
          </showman-table>
        </div>
      </div>
    </template>
    <template v-else-if="listType === 'check-in'">
      <div class="hr"></div>
      <div v-for="(e, i) in groupedEntries" :key="i">
        <div v-if="e[0].exhibitor" class="mb-6 border rounded-t">
          <p class="w-full text-2xl bg-gray-400 p-2 rounded-t"><span v-if="e[0].exhibitor.exhibitor_number">{{`${e[0].exhibitor.exhibitor_number} - `}}</span>{{`${e[0].exhibitor.first_name} ${e[0].exhibitor.last_name} (${e.length})`}}</p>
          <showman-table :hover="false" :tableData="e" :tableFields="checkinFields" :showHeaders="false">
            <div slot="Check In" slot-scope="data" class="flex flex-col text-center">
              <template v-if="!data.item.checked_in">
                <button title="Check In Entry"  class="btn-green btn-sm" @click="checkInEntry(data.item)">
                  Check In
                </button>
                <button class="btn-xs btn-blue-outline mt-1 text-sm" @click="$refs.entryEdit.editEntryClicked(entryTypeDecode[showDecode[data.item.shows[0]].entry_details_id], data.item, entryGroup.entry_group_id, entryGroup.user.user_id)"> &#9998; Edit</button>
                <button @click="scratchEntry(data.item)" class="btn-xs btn-link text-sm">
                  Scratch<template v-if="data.item.shows.length > 1"> All</template>
                </button>
              </template>
              <button v-else class="mb-1 btn-red-outline btn-xs text-sm" @click="undoCheckInEntry(data.item)">Undo Check In</button>
            </div>
            <div slot="Entry" slot-scope="data" class="flex flex-col md:flex-row items-center" :class="{'highlighted-row': data.item.highlight}">
              <div class="other-info w-full md:w-1/2">
                <!--Basic Entry Info-->
                <div class="flex flex-col justify-between mb-2">
                  <div v-if="showDecode[data.item.shows[0]].entry_details.entry_details[0]">
                    <div v-if="data.item.entry_details.name" class="font-semibold text-lg md:text-xl mb-1">{{data.item.entry_details.name}}</div>
                    <!--Check In Quick Edits-->
                    <div class="flex flex-wrap">
                      <div class="flex flex-col pr-2 w-full lg:w-1/2 mb-1" v-if="showDecode[data.item.shows[0]].entry_details.class_calc.calculate_by === 'weight' || data.item.entry_details.weight || getClassBreakType(data.item) === 'weight' || showDecode[data.item.shows[0]].entry_details.entry_details[0].fields.filter(f => f.model === 'weight').length > 0">
                        <span class="text-xs font-bold text-gray-700">{{getWeightLabel(data.item).toUpperCase()}}</span>
                        <input :disabled="data.item.checked_in" type="number" min="0" v-model="data.item.entry_details.weight" :placeholder="getWeightLabel(data.item)" @change="weighInEntry(data.item)" class="border border-gray-500 rounded p-1 focus:outline-none focus:shadow-outline text-base">
                        <button class="link text-sm mt-1.5" v-if="!data.item.checked_in && data.item.shows.length > 1" @click="makeSeperateWeights(data.item)">Record separate weights</button>
                      </div>
                      <template v-for="(f, i) in showDecode[data.item.shows[0]].entry_details.entry_details[0].fields" >
                        <div v-if="f.model === showDecode[data.item.shows[0]].entry_details.class_calc.animal_id_field" class="flex flex-col pr-2 w-full lg:w-1/2 mb-1" :key="i">
                          <span class="text-xs font-bold text-gray-700">{{f.label}}</span>
                          <input :disabled="data.item.checked_in" type="text" min="0" v-model="data.item.entry_details[showDecode[data.item.shows[0]].entry_details.class_calc.animal_id_field]" @change="weighInEntry(data.item)" class="border border-gray-500 rounded p-1 focus:outline-none focus:shadow-outline text-base">
                        </div>
                        <div v-if="f.model === 'animal_id' && !showDecode[data.item.shows[0]].entry_details.class_calc.animal_id_field" class="flex flex-col pr-2 w-full lg:w-1/2 mb-1" :key="i">
                          <span class="text-xs font-bold text-gray-700">{{f.label}}</span>
                          <input :disabled="data.item.checked_in" type="text" min="0" v-model="data.item.entry_details.animal_id" @change="weighInEntry(data.item)" class="border border-gray-500 rounded p-1 focus:outline-none focus:shadow-outline text-base">
                        </div>
                      </template>
                    </div>
                    <div class='flex flex-row justify-between md:justify-start text-gray-900 flex-wrap'>
                      <template v-for="(f, i) in showDecode[data.item.shows[0]].entry_details.entry_details[0].fields" >
                        <div v-if="f.model !== 'animal_id' && f.model !== 'weight' && f.model !== 'name' && f.model !== 'division'"  class="pr-3 text-sm mb-1" :key="i">
                          <template v-if="f.type==='picture'">
                            <div class="flex">
                              <img :src="data.item.entry_details[f.model]"/>
                            </div>
                          </template>
                          <template v-if="f.type === 'video'">
                            <video width="320" height="240" controls>
                              <source :src="data.item.entry_details[f.model]" type="video/mp4">
                              <source :src="data.item.entry_details[f.model]" type="video/webm">
                              <source :src="data.item.entry_details[f.model]" type="video/ogg">
                            </video>
                          </template>
                          <template v-else-if="f.type==='file'">
                            <div class="font-bold text-xs text-gray-800">{{f.label}}</div>
                            <display-file-type-field :url="data.item.entry_details[f.model]" :title="`${f.label} - ${data.item.entry_details['animal_id']}`"/>
                          </template>
                          <template v-if="f.type==='link'">
                            <a v-if="data.item.entry_details[f.model]" :href="`${data.item.entry_details[f.model]}`" target="_blank" class="link">{{`${data.item.entry_details[f.model]}`}}</a>
                          </template>
                          <template v-if="f.type==='input'">
                            <template v-if="f.inputType === 'text' || f.inputType === 'number'">
                              <div class="font-bold text-xs text-gray-800">{{f.label}}</div>
                              <div class="p-0 md:pr-2" v-if="f.model !== 'name'">{{data.item.entry_details[f.model] ? data.item.entry_details[f.model] : '---'}}</div>
                            </template>
                            <template v-else-if="f.inputType === 'date'">
                              <div class="font-bold text-xs text-gray-800">{{f.label}}</div>
                              <div class="p-0 md:pr-2">{{data.item.entry_details[f.model] ? formatDate(data.item.entry_details[f.model]) : '---'}}</div>
                            </template>
                          </template>
                          <template v-else-if="f.type === 'select'">
                            <div class="font-bold text-xs text-gray-800">{{f.label}}</div>
                            <div class="p-0 md:pr-2" v-if="f.model !== 'name'">{{data.item.entry_details[f.model] ? data.item.entry_details[f.model] : '---'}}</div>
                          </template>
                          <template v-else-if="f.type === 'checkbox'">
                            <div class="p-0 md:pr-2"><div class="font-bold text-xs">{{f.label}}:</div> {{data.item.entry_details[f.model] ? 'Yes' : 'No'}}</div>
                          </template>
                        </div>
                      </template>
                    </div>
                    <template v-if="showDecode[data.item.shows[0]].entry_details.sub_entry_details" >
                      <div v-for="(s, i) in showDecode[data.item.shows[0]].entry_details.sub_entry_details" :key="i" class='flex flex-row justify-between md:justify-start text-gray-900 flex-wrap'>
                        <div v-for="(f, j) in s[0].fields" :key="j" class="pr-2 text-sm mb-1">
                          <template v-if="f.type==='input'">
                            <template v-if="f.inputType === 'text' || f.inputType === 'number'">
                              <div class="font-bold text-xs text-gray-800">{{f.label}}</div>
                              <div class="p-0 md:pr-2" v-if="f.model !== 'name'">{{data.item.entry_details[f.model] ? data.item.entry_details[f.model] : '---'}}</div>
                            </template>
                            <template v-else-if="f.inputType === 'date'">
                              <div class="font-bold text-xs text-gray-800">{{f.label}}</div>
                              <div class="p-0 md:pr-2">{{data.item.entry_details[f.model] ? formatDate(data.item.entry_details[f.model]) : '---'}}</div>
                            </template>
                          </template>
                          <template v-else-if="f.type === 'select'">
                            <div class="font-bold text-xs text-gray-800">{{f.label}}</div>
                            <div class="p-0 md:pr-2" v-if="f.model !== 'name'">{{data.item.entry_details[f.model] ? data.item.entry_details[f.model] : '---'}}</div>
                          </template>
                          <template v-else-if="f.type === 'checkbox'">
                            <div class="p-0 md:pr-2"><div class="font-bold text-xs">{{f.label}}:</div> {{data.item.entry_details[f.model] ? 'Yes' : 'No'}}</div>
                          </template>
                        </div>
                      </div>
                    </template>
                    <p v-if='data.item.last_updated_at' class='text-xs text-gray-600'>Last Edited: {{Localized.formatDateTime(data.item.last_updated_at, event.location_details.country)}}</p>
                  </div>
                </div>
              </div>
              <div class="class-info w-full md:w-1/2 md:pl-2 pt-1 md:pt-0">
                <div class="text-xl md:font-bold flex">
                  {{getClassName(data.item)}}
                </div>
                <div v-if="data.item.shows">
                  <div v-for="(show, i) in data.item.shows" :key="i" class='flex border-t my-1 pt-1 items-center'>
                    <button @click="scratchShowEntry(data.item.entry_ids[i], showDecode[show.show_id ? show.show_id : show].name)" v-if="data.item.shows.length > 1 && !data.item.checked_in" type="button" class="inline-flex items-center px-2 py-1 border border-transparent text-xs font-medium rounded text-red-700 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">Scratch</button>
                    <p class="ml-1 text-base md:text-base text-gray-800 ">{{showDecode[show.show_id ? show.show_id : show].name}} </p>
                  </div>
                </div>
                <div class="mt-3 font-bold" v-if="typeof data.item.entry_numbers[0] !== 'undefined' && data.item.entry_numbers[0] !== null">
                  <span>Entry Number - </span>
                  <template v-if="data.item.editEntryNumber">
                    <input v-model="data.item.entry_numbers[0]" type="text" class="border border-gray-300 rounded-md p-1 text-sm w-24">
                    <span class="ml-2 text-xs link" @click="saveEditEntryNumber(data.item)">Save</span>
                    <span class="ml-2 text-xs link" @click="cancelEditEntryNumber(data.item)">Cancel</span>
                  </template>
                  <template v-else>
                    <span>{{data.item.entry_numbers[0]}}</span>
                    <span class="ml-2 text-xs link" @click="setItemEntryNumberEdit(data.item)">Edit</span>
                  </template>
                  <div>
                    <button class="btn-xs btn-blue-outline text-sm mt-1.5" v-if="data.item.shows.length > 1" @click="makeSeperateWeights(data.item)">Use separate number</button>
                  </div>
                </div>
              </div>
            </div>
            <div slot=" " slot-scope="data" v-if="editable && !data.item.checked_in">
              <div class="flex flex-col justify-end">
                <button class="btn btn-link mb-2 md:mb-0 text-sm" @click="$refs.entryEdit.editEntryClicked(entryTypeDecode[showDecode[data.item.shows[0]].entry_details_id], data.item, entryGroup.entry_group_id, entryGroup.user.user_id)">Edit</button>
                <button @click="scratchEntry(data.item)" class="btn btn-link text-sm">Scratch</button>
              </div>
            </div>
          </showman-table>
        </div>
      </div>
    </template>
    <entry-edit-wrapper v-if="listType !== 'preview'" ref="entryEdit" :isAdmin="isAdmin" :event="event"/>
  </div>
</template>

<script>
import EntryEditWrapper from '@/components/EntryEditWrapper.vue'

import Vue from 'vue'

export default {
  components: {
    EntryEditWrapper
  },
  props: {
    event: Object,
    entryGroup: Object,
    user: Object,
    isAdmin: {
      type: Boolean,
      default: false
    },
    listType: {
      default: 'tabs',
      type: String
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      entryFields: [
        {key: 'Entry'},
        {key: 'Class'},
        {key: ' '}
      ],
      checkinFields: [
        {key: 'Check In'},
        // {key: 'Class'},
        {key: 'Entry'}
        // {key: ' '}
      ]
    }
  },
  methods: {
    entryTypeClicked (entryType) {
      if (this.listType !== 'preview') {
        this.$refs.newEntryDD.close()
        this.$refs.entryEdit.newEntryClicked(entryType, this.entryGroup.entry_group_id, this.entryGroup.user.user_id)
      }
    },
    formatDate: function (date) {
      if (!date) return ''
      return this.Localized.formatDate(date, this.event.location_details.country)
    },
    groupBy: function (xs, key, secondary) {
      if (!secondary) {
        return xs.reduce(function (rv, x) {
          (rv[x[key]] = rv[x[key]] || []).push(x)
          return rv
        }, {})
      } else {
        return xs.reduce(function (rv, x) {
          (rv[x[key][secondary]] = rv[x[key][secondary]] || []).push(x)
          return rv
        }, {})
      }
    },
    getClassName (entry) {
      let cn = this.entryTypeDecode[this.showDecode[entry.shows[0]].entry_details_id].class_list.find(cl => cl.classID === entry.class_id)
      return cn ? cn.className : 'CLASS NOT FOUND'
    },
    getClassBreakType (entry) {
      let c = this.entryTypeDecode[this.showDecode[entry.shows[0]].entry_details_id].class_list.find(cl => cl.classID === entry.class_id)
      return c ? c.break_type : null
    },
    checkInEntry (e) {
      e.checked_in = new Date()
      this.$store.dispatch('setCheckInEntry', {
        updateEntry: e
      })
        .catch(() => {
          e.checked_in = null
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error checking entry in, please refresh the browser and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    undoCheckInEntry (e) {
      let lastValue = e.checked_in
      e.checked_in = null
      this.$store.dispatch('setCheckInEntry', {
        updateEntry: e
      })
        .catch(() => {
          e.checked_in = lastValue
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error undoing check in, please refresh the browser and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    weighInEntry (e) {
      let idField = this.showDecode[e.shows[0]].entry_details.class_calc.animal_id_field
      if (idField) {
        e.entry_details.animal_id = e.entry_details[idField]
      }
      this.$store.dispatch('updateEntryWeight', {
        updateEntry: e
      })
        .catch(() => {
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error recording weight, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    scratchEntry (e) {
      // Confirm Scratch
      this.notie.confirm({
        text: `Are you sure you want to delete this entry?`,
        submitCallback: () => {
          this.$refs.entryEdit.deleteEntry(e, this.entryGroup.entry_group_id)
        }
      })
    },
    scratchShowEntry (entryID, show) {
      this.notie.confirm({
        text: `Are you sure you want to delete this entry from the ${show}?`,
        submitCallback: () => {
          this.$refs.entryEdit.deleteIndividualEntry(entryID, this.entryGroup.entry_group_id)
        }
      })
    },
    makeSeperateWeights (item) {
      item.entry_ids.forEach((id, i) => {
        this.$store.state.apiInstance.put(`/data/entries/${id}`, {sep_id: i})
          .then(() => {
            if (i === item.entry_ids.length - 1) {
              this.$emit('refresh', this.entryGroup)
            }
          })
      })
    },
    setItemEntryNumberEdit (item) {
      Vue.set(item, 'orginalEntryNumber', item.entry_numbers[0])
      Vue.set(item, 'editEntryNumber', true)
    },
    cancelEditEntryNumber (item) {
      Vue.set(item, 'editEntryNumber', false)
      Vue.set(item, 'entry_numbers', [item.orginalEntryNumber])
    },
    saveEditEntryNumber (item) {
      let promises = []
      item.entry_ids.forEach(eid => {
        promises.push(this.$store.state.apiInstance.put(`/data/entries/${eid}`, {entry_number: item.entry_numbers[0]}))
      })
      Promise.all(promises)
        .then(() => {
          Vue.set(item, 'editEntryNumber', false)
          this.$emit('refresh')
        })
    },
    getWeightLabel (e) {
      let et = this.entryTypeDecode[this.showDecode[e.shows[0]].entry_details_id]
      let label = et.class_calc.declared_weight ? 'Declared Weight' : 'Weight'
      this.showDecode[e.shows[0]].entry_details.entry_details[0].fields.forEach(f => {
        if (f.model === 'weight') {
          label = f.label
        }
      })
      return label
    },
    checkEntryTypeEditable (item) {
      let et = this.entryTypeDecode[item.entry_details_id]
      return et.status !== 'ADMIN' || this.isAdmin
    }
  },
  computed: {
    showDecode () {
      var obj = {}
      if (this.event) {
        this.event.shows.forEach(s => {
          obj[s.show_id] = s
        })
      }
      return obj
    },
    entryTypeDecode () {
      var obj = {}
      if (this.event) {
        this.event.show_types.forEach(et => {
          obj[et.event_show_type_id] = et
        })
      }
      return obj
    },
    entryTabs () {
      let tabs = []
      let grouped = {}
      if (this.event.entry_settings.group_by === 'SPECIES') {
        this.event.species_types.forEach(s => {
          if (!tabs.find(sp => {
            return s.species === sp.label
          })) {
            tabs.push({
              label: s.species,
              show_ids: s.show_ids,
              entry_details: {},
              type: s.species
            })
          }
        })
        tabs.sort((a, b) => {
          if (a.label > b.label) {
            return 1
          } else if (a.label < b.label) {
            return -1
          } else {
            return 0
          }
        })
      } else {
        let ets = [...this.event.show_types]
        grouped = this.groupBy(ets, 'group_type')
        Object.keys(grouped).forEach(key => {
          tabs.push({
            label: key,
            type: key
          })
        })
      }
      return tabs
    },
    entries () {
      let entries = [...this.entryGroup.entries]
      entries.forEach(e => {
        e.species = this.showDecode[e.shows[0]].species
        e.entry_details_id = this.showDecode[e.shows[0]].entry_details_id
        e.type = this.entryTypeDecode[this.showDecode[e.shows[0]].entry_details_id].group_type // this.entryTypeDecode[e.entry_details_id].group_type // this.showDecode[e.shows[0]].type
      })
      return entries
    },
    groupedEntries () {
      /* let entries = [...this.entries].sort((a, b) => {
        if (a.checked_in > b.checked_in) return 1
        else if (b.checked_in > a.checked_in) return -1
        else return 0
      }) */
      if (this.listType === 'check-in') {
        return this.groupBy(this.entries, 'exhibitor', 'exhibitor_id')
      } else if (this.event.entry_settings.group_by === 'SPECIES') {
        return this.groupBy(this.entries, 'species')
      } else {
        return this.groupBy(this.entries, 'type')
      }
    }
  }
}
</script>

<style>
  .h_dd {
    max-height: 40rem;
  }
  .highlighted-row {
    border: 3px solid red;
    padding: 0.5rem;
  }
</style>
